
// 首页——主流程
const MainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `page/homePage/index${i + 1}`,
  name: `page/homePageIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/homePage/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 首页——主流程，开始
    ...MainRoutes
  ]
}
